import { createReducer, on } from '@ngrx/store';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import * as configurationProfileActions from './config-profile.actions';
import { SavingStatus } from '../../../shared/models/list.page.model';
import { ConfigurationProfileState } from './config-profile.models';

export const initialConfigurationProfileState: ConfigurationProfileState = {
  profiles: [],
  profilesPage: null,
  profilesPagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  profilesSaveInProgress: SavingStatus.NotStarted,
  error: null,
  loading: false,
};

export const configurationProfileReducer = createReducer(
  initialConfigurationProfileState,
  on(configurationProfileActions.loadConfigurationProfileList, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    configurationProfileActions.loadConfigurationProfileListFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error: error.errorMessage ?? 'Error',
    })
  ),
  on(
    configurationProfileActions.loadConfigurationProfileListSuccess,
    (state, { pagedResponse }) => ({
      ...state,
      loading: false,
      error: null,
      profiles: pagedResponse.result ?? [],
      profilesPage: {
        ...state.profilesPage,
        totalCount: pagedResponse.total ?? 0,
        pageIndex: pagedResponse.pageIndex ?? 0,
        pageSize: pagedResponse.pageSize ?? 0,
      },
    })
  ),
  on(
    configurationProfileActions.changeConfigurationProfilePagination,
    (state, { pageIndex, pageSize }) => ({
      ...state,
      profilesPagination: {
        pageIndex,
        pageSize,
      },
    })
  ),
  on(configurationProfileActions.updateConfigurationProfile, (state) => ({
    ...state,
    loading: true,
    profilesSaveInProgress: SavingStatus.InProgress,
  })),
  on(
    configurationProfileActions.updateConfigurationProfileSuccess,
    (state) => ({
      ...state,
      loading: false,
      profilesSaveInProgress: SavingStatus.Successful,
    })
  ),
  on(
    configurationProfileActions.updateConfigurationProfileFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      profilesSaveInProgress: SavingStatus.Failure,
      error: error.errorMessage ?? 'ERROR',
    })
  ),
  on(
    configurationProfileActions.insertNewConfigurationProfileSuccess,
    (state) => ({
      ...state,
      loading: false,
      profilesSaveInProgress: SavingStatus.Successful,
    })
  ),
  on(
    configurationProfileActions.insertNewConfigurationProfileFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      profilesSaveInProgress: SavingStatus.Failure,
      error: error.errorMessage ?? 'ERROR',
    })
  ),
  on(
    configurationProfileActions.deleteNewConfigurationProfileSuccess,
    (state) => ({
      ...state,
      profilesSaveInProgress: SavingStatus.Successful,
    })
  ),
  on(
    configurationProfileActions.insertNewConfigurationProfileFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      profilesSaveInProgress: SavingStatus.Failure,
      error: error.errorMessage ?? 'ERROR',
    })
  )
);
